module.exports = __webpack_public_path__ + "img/banner.87fc30ba.jpg";